/*
  NBV2 FAQ search (sections/nbv2-faq-hero.liquid)

  Live-filters every NBV2 FAQ list on the page (sections/nbv2-faq.liquid) by
  the hero's search field. Each item carries its question + answer text,
  pre-lowercased in Liquid, in data-search-text, so filtering is a plain
  substring test with nothing to parse here.

  Listeners are delegated from the document, so a hero or list re-rendered by
  the theme editor needs no re-initialisation.
*/
(function () {
  'use strict';

  if (window.nbv2FaqSearchLoaded) return;
  window.nbv2FaqSearchLoaded = true;

  var INPUT_SELECTOR = '[data-nbv2-faq-search]';
  var LIST_SELECTOR = '[data-nbv2-faq]';
  var ITEM_SELECTOR = '[data-nbv2-faq-item]';
  var EMPTY_SELECTOR = '[data-nbv2-faq-empty]';
  var DEBOUNCE_MS = 100;

  var timer = null;

  function normalize(value) {
    return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function filter(query) {
    var lists = document.querySelectorAll(LIST_SELECTOR);

    Array.prototype.forEach.call(lists, function (list) {
      var items = list.querySelectorAll(ITEM_SELECTOR);
      var visible = 0;

      Array.prototype.forEach.call(items, function (item) {
        var match = !query || (item.getAttribute('data-search-text') || '').indexOf(query) !== -1;
        item.hidden = !match;
        if (match) visible += 1;
      });

      var empty = list.querySelector(EMPTY_SELECTOR);
      if (empty) empty.hidden = visible > 0 || items.length === 0;
    });
  }

  function currentQuery() {
    var input = document.querySelector(INPUT_SELECTOR);
    return input ? normalize(input.value) : '';
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches(INPUT_SELECTOR)) return;
    var query = normalize(event.target.value);
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      filter(query);
    }, DEBOUNCE_MS);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!event.target.matches || !event.target.matches(INPUT_SELECTOR)) return;
    event.target.value = '';
    window.clearTimeout(timer);
    filter('');
  });

  /* A list re-rendered in the theme editor comes back unfiltered. */
  document.addEventListener('shopify:section:load', function () {
    filter(currentQuery());
  });
})();
